import React, { useEffect, useState } from 'react';
import '../../../index.scss';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
import GetAppIcon from '@material-ui/icons/GetApp';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { setLoadingRedux } from 'reducers/shareData/action';
import { isType3, userTypeList } from 'main_consts';

import styled from 'styled-components';
import WarehouseModal from 'components/Modal/WareHouseModal';
import CheckBox from 'components/Material/Checkbox';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';
import colW from 'components/NewTable/consts';
import { TableColumn } from 'components/NewTable/type';
import NewTable from 'components/NewTable/index';
// component
import Header from 'components/Header';
import Menu from '../../../components/Menu';
import {
  formatDateTime,
  getDateDayPlus,
  getExpressName,
  getWarehouse,
  inputChange,
  checkboxChange,
  initWhrehhouse,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSearch,
  snackBarRsp,
} from '../../../main_api';

// import Table from '../../../components/Material/Table/index';

import { IrptManifestNoInList, Imaster } from './type';
import { Iobject } from '../../../main_type';

/** 已申報未入倉清單 */
const RptManifestNoInQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  const masterDefaultValue: Imaster = {
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 主號
    mawbNo: '',
    // 櫃號
    containerNo: '',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    timeCheck: '0',
    endDateValid: true,
    endTimeValid: true,
    startDateValid: true,
    startTimeValid: true,
    pageSize: 100,
  };
  const apiName = 'rptManifestNoInQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [rowData, setRowData] = useState<IrptManifestNoInList[]>([]);
  // const [colList, setColList] = useState<GridColDef[]>([]);
  const [listCol, setListCol] = useState<TableColumn[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  // const [resultOther, setResultOther] = useState<IresultOther>(
  //   {} as IresultOther
  // );

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  const DivStyle = styled.div`
    border: 3px outset #1c6ea4;
    margin-bottom: 1rem;
  `;

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getExcel(apiName, {
      expressid: master.chkCode1,
      warehouse: master.warehouse,
      // declType: master.declType,
      mawbNo: master.mawbNo,
      containerNo: master.containerNo,
      // closeMark: master.closeMark,
      startDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.startDate, `${master.startTime}00`),
      endDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.endDate, `${master.endTime}59`),
    });
    // const startDate = formatDateTime(
    //   master.startDate,
    //   master.startTime,
    //   'MMdd'
    // );
    // const EndDate = formatDateTime(master.endDate, master.endTime, 'MMdd');

    blobDownload(
      result,
      enqueueSnackbar,
      `${
        master.chkCode1.length > 0 ? `${master.chkCode1}_` : ''
      }艙報單已申報此分號無刷碼記錄.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getSearch(apiName, {
      expressid: master.chkCode1,
      warehouse: master.warehouse,
      // declType: master.declType,
      mawbNo: master.mawbNo,
      containerNo: master.containerNo,
      // closeMark: master.closeMark,
      startDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.startDate, `${master.startTime}00`),
      endDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.endDate, `${master.endTime}59`),
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const rptManifestNoInList = result.data.data as IrptManifestNoInList[];

    if (rptManifestNoInList) {
      // console.log(rptManifestNoInList);

      if ((rptManifestNoInList || []).length > 0) {
        setListCol([
          { w: colW[1], t: '項次', f: 'itemNo' },
          { w: colW[8], t: '主號', f: 'mawbNo' },
          { w: colW[8], t: '分號', f: 'hawbNo' },
          { w: colW[2], t: '海掛', f: 'vesselRegNo' },
          { w: colW[8], t: '艙號', f: 'manifNo' },
          { w: colW[8], t: '櫃號', f: 'fullContainerNo' },
          { w: colW[2], t: '記帳代號', f: 'expressid' },
        ]);
        setRowData(rptManifestNoInList);
        setOpenSearchTable(true);
      } else {
        setOpenSearchTable(false);
      }
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    if (master.mawbNo.length <= 0 && master.timeCheck === '0') {
      enqueueSnackbar('【主號】或【艙單日期區間】擇一必填。', {
        variant: 'warning',
      });
      return;
    }

    if (
      (master.timeCheck === '1' &&
        (!master.endDateValid ||
          !master.endTimeValid ||
          !master.startDateValid ||
          !master.startTimeValid)) ||
      !(
        master.startDate &&
        master.endTime &&
        master.startDate &&
        master.startTime
      )
    ) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };
  const handleDownloadBarcode = () => {
    window.location.href = '/3of9BarcodeRegular.ttf';
  };
  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area" />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 艙報單已申報此分號無刷碼記錄查詢
          </div>
        </div>
        <div className="input-area">
          {/* 20210325 新增權限判斷 */}
          {userType && !isType3(userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>

              <VcGrid item xs={12} sm={3}>
                <Input
                  name="chkCode1"
                  disabled={userTypeList.type2.indexOf(userType) !== -1}
                  maxLength={4}
                  value={master.chkCode1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={3}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={3}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              主號：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                placeholder="主號或艙單日期區間擇一必填"
                maxLength={35}
                value={master.mawbNo}
                name="mawbNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              櫃號：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                maxLength={35}
                value={master.containerNo}
                name="containerNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              艙單日期區間：
            </VcEGrid>
            <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
              <DateTimeSePickersTyping
                key={random}
                required={master.timeCheck === '1'}
                disabled={master.timeCheck === '0'}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={[
                  ['startDate', 'startTime'],
                  ['endDate', 'endTime'],
                ]}
                data={master}
                setDayRange={7}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入時間查詢"
                checked={master.timeCheck === '1'}
                name="timeCheck"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    startDate: masterDefaultValue.startDate,
                    startTime: masterDefaultValue.startTime,
                    endDate: masterDefaultValue.endDate,
                    endTime: masterDefaultValue.endTime,
                    ...checkboxChange()(['1', '0'])(e),
                  }));
                }}
              />
            </VcGrid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              variant="outlined"
              color="primary"
              startIcon={<GetAppIcon />}
              onClick={() => handleDownloadBarcode()}
            >
              下載BarCode字型
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <>
          <NewTable<IrptManifestNoInList>
            data={rowData}
            columns={listCol}
            pageSize={master.pageSize}
            pageSizeOptions={[100, 50, 10]}
          />
          {/* <Table
            key={randomValue}
            data={rowData as unknown as Iobject[]}
            columns={colList}
            rowsPerPageOptions={[100, 50, 10]}
            rootProps={{ style: { height: '400px' } }}
            pageSize={100}
          /> */}
        </>
      )}
    </div>
  );
};

export default RptManifestNoInQry;
